import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import classNames from 'classnames';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import useLegendEventHandler from './useLegendEventHandler';

const useStyles = buildUseStyles('BenchmarkChartLegendItem', ((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
    cursor: 'pointer',
  },
})));

const BenchmarkChartLegendItem = ({
  className,
  name,
  color,
  showBenchmark,
  toggleShowBenchmark,
}) => {
  const classes = useStyles();

  const {
    handleLegendClick,
  } = useLegendEventHandler();

  const handleBenchmarkClick = (itemName) => {
    handleLegendClick(itemName);
    toggleShowBenchmark();
  };

  return (
    <Box
      className={classNames(classes.root, className)}
      onClick={() => handleBenchmarkClick(name)}
    >
      {showBenchmark && <VisibilityIcon style={{ color }} fontSize={'small'} />}
      {!showBenchmark && <VisibilityOffIcon color={'disabled'} fontSize={'small'} />}
      <Text
        text={name}
        align={'left'}
        color={'primaryGray'}
        weight={'bold'}
        variant={'h6'}
      />
    </Box>
  );
};

BenchmarkChartLegendItem.defaultProps = {
  className: '',
};

BenchmarkChartLegendItem.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  showBenchmark: PropTypes.bool.isRequired,
  toggleShowBenchmark: PropTypes.func.isRequired,
};

export default BenchmarkChartLegendItem;
